import { useMemo, useState } from 'react';
import i18n from '../../../../../i18n';

interface CommentThreadType {
  id: number;
  key: string;
  label: string;
}
type Props = {
  editor: any;
  threadId: string;
  setCommentTypeDialogIsOpen: (isOpen: boolean) => void;
  onCancel: () => void;
};

// constants
const commentTheradTypes: CommentThreadType[] = [
  { id: 1, key: 'button-1', label: i18n.t('懸案項目') },
  { id: 2, key: 'button-2', label: i18n.t('研究所質問') },
  { id: 3, key: 'button-3', label: i18n.t('Prod.⇒原作') },
  { id: 4, key: 'button-4', label: i18n.t('原作⇒Prod.') },
  { id: 8, key: 'button-8', label: i18n.t('Validation Prod.用') },
  { id: 9, key: 'button-9', label: i18n.t('Validation 原作用') },
];

function CommentTypePage({ editor, threadId, setCommentTypeDialogIsOpen, onCancel }: Props): JSX.Element {
  // Data
  const [currentCommentTypeId, setCurrentCommentTypeId] = useState<number>(-1);
  const originalThreadTypeId: number = useMemo(() => {
    if (threadId) {
      const threadIdParts = threadId.split('-');
      return Number(threadIdParts[0]);
    }

    return -1;
  }, [threadId]);
  const filteredCommentThreadTypes = useMemo(
    () => commentTheradTypes.filter((type) => type.id !== originalThreadTypeId),
    [originalThreadTypeId]
  );
  const originalThreadTypeLabel: string = useMemo(() => {
    const threadType = commentTheradTypes.find((type) => type.id === originalThreadTypeId);
    return threadType ? threadType.label : '';
  }, [originalThreadTypeId]);

  /* eslint-disable */
  const commentsRepository = editor.plugins.get('CommentsRepository') as any;
  const commentThread = commentsRepository.getCommentThread(threadId) as any;
  /* eslint-enable */

  // Events
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const selectedId = Number(event.target.value);
    setCurrentCommentTypeId(selectedId);
  };
  const handleCancel = (): void => {
    onCancel();
  };

  const handleSubmit = (): void => {
    // Duplicate the thread

    /* eslint-disable */
    const newThreadId = editor.utils.getNewThreadId(currentCommentTypeId);
    const elements: NodeListOf<Element> = document.querySelectorAll(`.ck-comment-marker[data-comment="${threadId}"]`);
    if (elements.length > 0) {
      const selection: Selection | null = window.getSelection();
      const range: Range = document.createRange();

      if (selection && range) {
        range.setStart(elements[0], 0);
        const lastElement: Element = elements[elements.length - 1];
        range.setEnd(lastElement, lastElement.childNodes.length);
        selection.removeAllRanges();
        selection.addRange(range);
        // Wait for the selection to be applied
        setTimeout(() => {
          editor.execute('addCommentThread', { threadId: newThreadId });
          const newCommentThread = commentsRepository.getCommentThread(newThreadId);
          commentThread.comments.map((comment: any) => {
            newCommentThread.addComment({
              commentId: editor.utils.uid(),
              authorId: comment.author.id,
              content: comment.content,
              createdAt: new Date(comment.createdAt),
            });
          });
          commentThread.remove();
          setCommentTypeDialogIsOpen(false);
        }, 100);
      }
    }
    /* eslint-enable */
  };

  return (
    <div>
      <div style={{ padding: '15px', marginBottom: '20px', backgroundColor: '#ffeeee', border: '5px solid #ee9999' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '5px', fontSize: '1rem' }}>
          <i className="fa fa-exclamation-circle" style={{ marginRight: '3px', color: '#C21413' }} />
          <div style={{ color: '#C21413', fontWeight: 'bold' }}>{i18n.t('注意')}</div>
        </div>
        <div style={{ fontSize: '.8rem', lineHeight: '1rem' }}>
          <strong style={{ textDecoration: 'underline' }}>
            {i18n.t('コメント区分を変更しても保存はされません。')}
            <br />
            {i18n.t('忘れず保存してください。')}
          </strong>
        </div>
      </div>
      <div style={{ marginBottom: '40px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '25px' }}>
          <div style={{ fontSize: '0.8rem', paddingLeft: '5px' }}>
            <strong>{originalThreadTypeLabel}</strong>
          </div>
          <div>
            <i className="fa fa-arrow-right" />
          </div>
          <div style={{ flex: '1' }}>
            <select
              style={{ height: '2rem', lineHeight: '2rem', fontSize: '.9rem' }}
              value={currentCommentTypeId}
              onChange={handleChange}
            >
              <option value="-1">{i18n.t('コメント区分を選択')}</option>
              {filteredCommentThreadTypes.map((type) => (
                <option key={type.key} value={type.id}>
                  {type.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div style={{ padding: '0', margin: '0 3px 0 3px', display: 'flex', gap: '15px' }}>
        <button
          type="button"
          className="cancelbtn"
          style={{ letterSpacing: '0', paddingRight: '12px', width: '100%' }}
          onClick={handleCancel}
        >
          {i18n.t('キャンセル')}
        </button>
        <input
          type="submit"
          style={{ letterSpacing: '0', paddingRight: '13px', width: '100%' }}
          value={i18n.t('変更する').toString()}
          className="searchbtn"
          disabled={currentCommentTypeId === -1}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}

export default CommentTypePage;
